module.exports = new __parcel__URL__("mathWallet.346af017.svg").toString();